import { TokenResponse } from 'types/login';

export { doGet as ssrGET } from './ssr';
export { doGet as webGET } from './web';

export const emptyToken: TokenResponse = { token_type: '', access_token: '', refresh_token: '', expires_in: -1 };
